import React from "react";
import Branches from "../Components/Branches";

function BranchPage() {
  return <Branches />;
}

export default BranchPage;
